import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=fe312d7c&scoped=true"
import script from "./CSelect.vue?vue&type=script&lang=js"
export * from "./CSelect.vue?vue&type=script&lang=js"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=fe312d7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe312d7c",
  null
  
)

export default component.exports